import { Typo3Section } from '@/types/typo3'

// A generic type to represent any object that might contain a plugin.
type PluginContainer = {
  plugin?: {
    hasShowOpenClosed?: boolean

    [key: string]: any // Allow other properties
  }

  [key: string]: any // Allow other properties
}

// A generic type for the plugin itself.
type GenericPlugin = {
  hasShowOpenClosed?: boolean

  [key: string]: any
}

export const getPlugin = (
  data?: Typo3Section | PluginContainer
): GenericPlugin | undefined => {
  if (!data) {
    return undefined
  }

  // Case 1: data.plugin exists at the top level
  if ('plugin' in data && data.plugin && typeof data.plugin === 'object') {
    return data.plugin as GenericPlugin
  }

  // Case 2: data.content is an array and might contain the plugin
  if (
    'content' in data &&
    Array.isArray(data.content) &&
    data.content.length > 0
  ) {
    // Find the first item in content that has a plugin object
    for (const item of data.content) {
      if (
        item &&
        typeof item === 'object' &&
        'plugin' in item &&
        item.plugin &&
        typeof item.plugin === 'object'
      ) {
        return item.plugin as GenericPlugin
      }
    }
  }

  return undefined
}
